export default "__VITE_ASSET__GhztaoDz__"